export const PERIOD_QUICK_SELECTIONS = [
  "today",
  "yesterday",
  "day_before_yesterday",
  "this_week",
  "last_week",
  "this_month",
  "last_month",
  "this_year",
  "last_year",
] as const;

export type PeriodQuickSelection = (typeof PERIOD_QUICK_SELECTIONS)[number];
